import React from 'react';
import ReactHighcharts from 'react-highcharts';
import Highcharts from 'highcharts';

const utils = require('../../components/utils');
const BORDER_COLOR = '#666666';
const REVENUE_COLOR = '#a0ce4e';
const IMPRESSIONS_COLOR = '#009fdb';

const TotalAuctionOptimizerComponent = ({totalAccepted, totalOptimized, loading, title}) => {
    const config = {
      chart: {
        id: 'OptimizerChart',
        renderTo: 'container',
        zoomType: 'x',
        // height: '74%',
        backgroundColor: 'none',
        borderColor: BORDER_COLOR,
        borderWidth: 1,
      },
      title: {
        text: title || '% OPTIMIZED REQUESTS',
        style: { color: '#ffffff', fontSize: '12px', fontWeight: 600 }
      },
      subtitle: {
        useHTML: false,
        text: totalOptimized && !loading ? `${utils.roundDouble((totalOptimized*100)/(totalOptimized+totalAccepted), 1)}%` :  '-',
        floating: true,
        verticalAlign: 'middle',
        style: { color: '#ffffff', fontSize: '20px', fontWeight: 600 },
      },
      xAxis: {
        type: 'datetime',
        labels: {
          format: '{value:%e-%b}',
          style: { color: '#ffffff', fontFamily: 'Roboto, Helvetica, Arial, sans-serif', fontSize: '11px', fontWeight: 600 }
        },
        crosshair: true,
        gridLineWidth: 0
      },
      yAxis: {
        labels: {
          style: { color: '#ffffff' }
        },
        title: {
          text: '%Optimized',
          style: { color: '#ffffff' }
        }
        , min: 0
        , gridLineWidth: 0,
        stackLabels: { enabled: true }
      },
      plotOptions: {
        pie: {
          dataLabels: { enabled: false },
          startAngle: -90,
          endAngle: 90,
          center: ['50%', '50%'],
          size: '100%',
          innerSize: '70%',
        }
      },
      series: [
        {
          name: '%Optimized',
          shadow: true,
          colors: [REVENUE_COLOR, IMPRESSIONS_COLOR],
          borderColor: 'white',
          borderWidth: 3,
          type: 'pie',
          animation: Highcharts.svg,
          showInLegend: false,
          tooltip: {
            pointFormat: '{point.percentage:.1f}%'
          },
          startAngle: -90,
          endAngle: -90
        }
      ],
      legend: { enabled: true, itemStyle: { color: '#ffffff' } }
      ,credits: { enabled: false }
    };
  
    config.series[0].data = loading ? [] : [
      ['Optimized', totalOptimized],
      ['Accepted', totalAccepted]
    ];

    return <ReactHighcharts config={config} /> 
}

export default TotalAuctionOptimizerComponent;